/**
 * Helpers for server-side list pagination (Vuetify 2 v-data-table).
 */
var paginationParams = require('../utils/paginationParams')

export default {
  methods: {
    buildPaginationParams: paginationParams.buildPaginationParams,
  },
}
